import { API_ENDPOINTS } from './src-config-api-config.js';
import { eventBus } from './src-utils-event-bus.js';

let bannerPageCache;
const isBannerPage = async () => {
  try {
    if (!bannerPageCache) {
      const response = await fetch(API_ENDPOINTS.PAGE_CONFIG);
      const data = await response.json();
      const currentURL = window.location.href;
      let matchedStyle = null;
      let allowed = false;
      if (data && data.bannerPageURls) {
        const allUrlsArray = Object.keys(data.bannerPageURls);
        allUrlsArray.forEach((url) => {
          if (currentURL.includes(url)) {
            matchedStyle = data.bannerPageURls[url];
            allowed = true;
          }
        });
        bannerPageCache = { allowed, matchedStyle };
        return { allowed, matchedStyle };
      }
      return { allowed: false, matchedStyle: null };
    }
    return bannerPageCache;
  } catch (error) {
    console.error("Error checking banner page config:", error);
    return { allowed: false, matchedStyle: null };
  }
};
const updatePPAGInlineButton = (buttonText, disabled, matchedStyle) => {
  const chatbuttons = document.querySelectorAll("#start-chat-button");
  chatbuttons.forEach((button) => {
    button?.removeAttribute("href");
    if (!disabled) {
      button.onclick = () => {
        eventBus.dispatch("onCAButtonClicked", {});
      };
    } else {
      button.onclick = () => {
      };
    }
    button.innerHTML = ` <img
      src="${disabled ? `${API_ENDPOINTS.CLOUDINARY_BASE_URL}/fl_sanitize,q_auto/help_center/chat-icon-disabled.svg` : matchedStyle === "white" ? `${API_ENDPOINTS.CLOUDINARY_BASE_URL}/fl_sanitize,q_auto/help_center/chat-icon-black.svg` : `${API_ENDPOINTS.CLOUDINARY_BASE_URL}/fl_sanitize,q_auto/help_center/chat-icon-white.svg`}"
      alt="image"
      class="swan-icon swan-icon-mask swan-icon-size-standard swan-icon-skin-standard swan-icon-type-image caHelpIconBg"
      id="caButtonIcon"
    />${buttonText}`;
    if (matchedStyle === "black" && !disabled) {
      button.style.backgroundColor = "#000000";
      button.style.borderColor = "#000000";
      button.style.color = "#ffffff";
    }
    if (matchedStyle === "white" && !disabled) {
      button.style.backgroundColor = "#ffffff";
      button.style.borderColor = "#ffffff";
      button.style.color = "#000000";
    }
    if (disabled) {
      button.style.backgroundColor = "#dfdfdf";
      button.style.borderColor = "#dfdfdf";
      button.style.color = "#9e9e9e";
    }
  });
};

export { isBannerPage, updatePPAGInlineButton };
//# sourceMappingURL=src-utils-chat-banner-page-utils.js.map
